import bar from './bar.js';


  const bars = new bar();
  console.log("bars 14.0");
  $("#createUser").click(function() {
    bars.createUser();
  });

  $("#login2").click(function() {
    bars.signIn();
  });

  $("#btn-login-terra").click(function() {
    bars.signInTerra();
  });

  $("#btn-autologin-terra").click(function() {
    bars.signInTerraAutologin();
  });

  $("#updateUser").click(function() {
    bars.updateEmail();
  });

  $("#storage").click(function() {
    bars.listStorage();
  });

  $("#logout,#logout2").click(function() {
    AbrilPaywall.controlBackButton = false;
    bars.signOut();
  });

 $("#updateStorage").click(function() {
    bars.updateStorage();
  });

  $("#loginGoogleSSO").click(function() {
    bars.loginGoogle();
  });

  $('body').on('click', '.favoritar', function() {  
    let postId = $(this).attr("data-postId");
    let postType = $(this).attr("data-postType");
    let marca = $(this).attr("data-marca");
    let dataFavoritadoEm = $(this).attr("data-favoritadoEm");
    bars.favoritar(postId,postType,marca,dataFavoritadoEm);
  });

  $('body').on('click', '.desFavoritar', function() {
    console.log( "clicou!" );
    let postId = $(this).attr("data-postId");
    let postType = $(this).attr("data-postType");  
    bars.desFavoritar(postId,postType);
  });

  window.addEventListener( "message",
  function (e) {
    if(e.data.action === "openSWGBuyFlow"){
      let eventLabel = AbrilLogin.setEventLabel();
      if(window.location.href.indexOf("/ofertas/") > 0 || window.location.href.indexOf("/ofertas") > 0) {
        eventLabel = 'Tela de ofertas';
      }
      let assineUrl = 'https://homolog-assine.abril.com.br/';
      if ( 'production' === assine_environment[0] ) {
        assineUrl = 'https://www.assine.abril.com.br/';
      }
      bars.swgBuyFlow( e.data.value, assineUrl, eventLabel );
      return;
    }
  }
);

export function startOnboarding() {
  console.log("!!!!!!!!!!!!  chamada externa Onboarding !!!!!!!!");
  //bars.testeExternal();
  bars.setListExecOnboarding(true);
}

export function startOntap(){
  console.log("!!!!!!!!!!!!  chamada externa OnTap !!!!!!!!");
  bars.setListExecOntap();
}

export function startLinking(){
  console.log("!!!!!!!!!!!!  chamada externa Linking !!!!!!!!");
  bars.setListExecLinking();
}

